<div class="navigation-bar">
  <div class="navigation-menu-left">
    <ul>
      <li><a routerLink="/my-projects">My Projects</a></li>
      <li style="margin-left: 24px;"><a routerLink="/my-organizations">My Organizations</a></li>
    </ul>
  </div>
  <div class="navigation-menu-right">
    <ul>

      <li><a routerLink="/privacy"><img src="assets/images/privacy-512.png"></a></li>

      <li><a routerLink="/help"><img src="assets/images/help-512.png"></a></li>

      <li *ngIf="isAdmin()"><a routerLink="/administration"><img src="assets/images/gear-512.png"></a></li>

      <li class="profile-button">
        <a routerLink="/profile" [innerHTML]="profilePic" class="profile-link"></a>
        <div class="profile-dropdown">

          <!-- current user session details -->

          <div *ngIf="!user; else userdropfill">No User</div>
          <ng-template #userdropfill>
            <div class="profile-dropdown-header">
              <span class="profile-dropdown-icon" [innerHTML]="profilePic"></span>
              <span class="profile-dropdown-title">{{user.firstName}} {{user.lastName}}</span>
            </div>
            <div class="profile-dropdown-content" style="padding: 0;">
              <table colspan="0" cellspacing="0" style="margin: 12px;">
                <tr>
                  <td style="text-align: right; padding-right: 12px;">eMail:</td><td>{{user.email}}</td>
                </tr>
                <tr>
                  <td style="text-align: right; padding-right: 12px;">user:</td><td>{{user.username}}</td>
                </tr>
                <tr>
                  <td style="text-align: right; padding-right: 12px;">auth:</td><td>{{user.token}}</td>
                </tr>
                <tr>
                  <td style="text-align: right; padding-right: 12px;">Expires:</td><td [innerHTML]="expiresLabel"></td>
                </tr>
                <tr>
                  <td style="padding-right: 12px;"><button class="gui-button primary" (click)="onRefresh()">Refresh</button></td>
                </tr>
              </table>
            </div>
          </ng-template>

        </div>
      </li>
      <li><a routerLink="/logout"><img src="assets/images/logout-512.png"></a></li>
    </ul>
  </div>
</div>
